module.exports = "/assets/data/a87064e56e4f691ae057a19dc412b166-DE74.data.json";